<template>
  <nav :class="$style.component" ref="nav">
    <ul :class="$style.list">
      <li :class="$style.item">
        <about-nav-button
          v-for="(item, index) in items"
          :key="`item-${index}`"
          :item="item"
          :index="index"
        />
      </li>
      <li :class="$style.item">
        <a
          :class="$style.instagram"
          href="https://www.instagram.com/kazuyookushiba/"
          target="_blank"
        />
      </li>
    </ul>
  </nav>
</template>

<script>
import VueScrollTo from 'vue-scrollto'
import AboutNavButton from '@/components/about-nav-button'

export default {
  components: {
    AboutNavButton
  },
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  methods: {
    scrollTo(el) {
      VueScrollTo.scrollTo('#' + el.name, { offset: this.scrollOffset })
    }
  }
}
</script>

<style lang="scss" module>
.component {
  position: sticky;
  z-index: 1;
  top: 0;
  column-count: 2;
  padding: var(--gutter) 0;
  border-bottom: 1px solid var(--dark-grey);
  background-color: var(--black);

  @media (min-width: $medium) {
    position: static;
    display: flex;
    column-count: 0;
    flex-direction: column;
    flex: 1;
    border-bottom: none;
    padding: 0 var(--gutter) 0 0;
  }
}

.list {
  @media (min-width: $medium) {
    position: sticky;
    top: var(--blank-line);
  }
}

.instagram {
  display: block;
  width: 100%;
  text-align: left;

  @media #{$mqHover} {
    transition: color var(--short) ease;

    &:hover {
      color: var(--white);
    }
  }
}

.instagram {
  &:after {
    @extend %ff-symbols;
    content: '\e003';
  }
}

.is-active {
  color: var(--white);
}
</style>
